import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import YouTube from 'react-youtube';
import CloseIcon from '@material-ui/icons/Close';
import { Container } from 'styles/components/VideoDialog';

const VideoDialog = ({ open, toggle, videoId }) => {
  const opts = {
    playerVars: {
      autoplay: 1,
    },
  };

  return (
    <Dialog
      PaperProps={{
        style: { backgroundColor: 'transparent', boxShadow: 'none' },
      }}
      fullWidth={true}
      maxWidth='lg'
      open={open}
      onClose={toggle}>
      <Container>
        <CloseIcon onClick={toggle} />
        <YouTube videoId={videoId} opts={opts} />
      </Container>
    </Dialog>
  );
};

VideoDialog.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
  videoId: PropTypes.string,
};

export default VideoDialog;
